import EditIcon from "../../../assets/Edit.svg";
import DeleteIcon from "../../../assets/Delete.svg";

export default function SpacingTable({ spacingData = [], onEdit, onDelete }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "20px",
        border: "1px solid #6B7280",
        borderRadius: "20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(150px, 2fr) minmax(120px, 1.2fr) minmax(120px, 1.2fr) minmax(120px, 1.2fr) minmax(200px, 2.5fr) minmax(100px, 1fr)",
          gap: "16px",
          padding: "13.5px 0 15px 0",
          borderBottom: "1px solid #D1D5DB",
        }}
      >
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Material
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Notes
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Up to Size
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Spacing
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Rod Size
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Action
        </p>
      </div>

      {spacingData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 0",
            color: "#6B7280",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          No spacing data available
        </div>
      ) : (
        spacingData.map((spacing, index) => (
          <div
            key={spacing.id}
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(150px, 2fr) minmax(120px, 1.2fr) minmax(120px, 1.2fr) minmax(120px, 1.2fr) minmax(200px, 2.5fr) minmax(100px, 1fr)",
              gap: "16px",
              padding: "13.5px 0",
              borderTop: index > 0 ? "1px solid #E5E7EB" : "none",
            }}
          >
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {spacing.material || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {spacing.notes || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {spacing.max_size || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {spacing.spacing || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {spacing.rod_size || "—"}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer" }}
                onClick={() => onEdit && onEdit(spacing)}
              />
              <img
                src={DeleteIcon}
                alt="Delete"
                style={{ cursor: "pointer" }}
                onClick={() => onDelete && onDelete(spacing)}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
}
